export const firstParam = (
  value?: string | string[] | number | null,
): string | undefined => {
  if (Array.isArray(value)) {
    return value[0] ? String(value[0]) : undefined;
  }

  if (value === undefined || value === null || value === '') {
    return undefined;
  }

  return String(value);
};

export const firstNumericParam = (
  value?: string | string[] | number | null,
  fallback?: number,
): number | undefined => {
  const raw = firstParam(value);
  if (raw === undefined) return fallback;
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : fallback;
};
